import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonProps,
  ToggleButtonGroupProps,
} from "@mui/material";
import { SelectionOption } from "../../../types";
import React from "react";

export type ItecToggleButtonGroupMultipleProps<
  TOption extends SelectionOption
> = {
  options: TOption[];
  onChange: (value: number[]) => void;
  renderOption?: (value: TOption) => React.ReactNode;
  toggleButtonProps?:
    | Omit<ToggleButtonProps, "value" | "key">
    | ((value: TOption) => Omit<ToggleButtonProps, "value" | "key">);
  value: number[] | undefined;
} & Omit<ToggleButtonGroupProps, "onChange">;

export function ItecToggleButtonGroupMultiple<TOption extends SelectionOption>(
  props: ItecToggleButtonGroupMultipleProps<TOption>
) {
  const { options, renderOption, onChange, value, toggleButtonProps, ...rest } =
    props;

  return (
    <ToggleButtonGroup
      value={value || []}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      {...rest}
    >
      {options.map((option) => (
        <ToggleButton
          value={option.value}
          key={option.value}
          {...(toggleButtonProps
            ? typeof toggleButtonProps === "function"
              ? toggleButtonProps(option)
              : toggleButtonProps
            : {})}
        >
          {renderOption ? renderOption(option) : option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
